import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "wc-mobile-ot-switcher__row wc-mobile-ot-switcher__row--centered"
}
const _hoisted_2 = ["aria-current", "disabled", "onClick"]
const _hoisted_3 = { class: "wc-mobile-ot-switcher__icon" }
const _hoisted_4 = { class: "wc-mobile-ot-switcher__label" }
const _hoisted_5 = ["aria-current", "disabled", "onClick"]
const _hoisted_6 = { class: "wc-mobile-ot-switcher__icon" }
const _hoisted_7 = { class: "wc-mobile-ot-switcher__label" }

import { inject, computed, ref, onMounted, onUnmounted } from 'vue';
import { Splide, SplideSlide } from '@splidejs/vue-splide';
import WCCarousel from '@/components/WCCarousel/WCCarousel.vue';
import WCImage from '@/components/WCImage/WCImage.vue';
import useOrderTypes from '@/composables/useOrderTypes';
import { configurationKey } from '@/injections';
import type OrderType from '@/models/entities/cart/order-type';


export default /*@__PURE__*/_defineComponent({
  __name: 'WCMobileOTSwitcher',
  setup(__props) {

const { visibleOrderTypes, currentOrderType, navigateToOrderTypeHome } = useOrderTypes();
const $configuration = inject(configurationKey);
const carouselRoot = ref<HTMLElement | null>(null);
const switching = ref(false);

const cdn = computed(() => $configuration?.cdn ?? '');
const orderTypeCount = computed(() => visibleOrderTypes.value?.length ?? 0);
const containerWidth = ref(typeof window !== 'undefined' ? window.innerWidth : 375);
const tileStride = ref(84);

const isDragEnabled = computed(() => {
  const totalTilesWidth = orderTypeCount.value * tileStride.value;
  return totalTilesWidth > (containerWidth.value - 32);
});

const measureDimensions = () => {
  const container = carouselRoot.value;
  if (!container) return;
  const measuredContainerWidth = container.getBoundingClientRect().width;
  if (measuredContainerWidth > 0) containerWidth.value = measuredContainerWidth;
  const tiles = container.querySelectorAll<HTMLElement>('.wc-mobile-ot-switcher__tile');
  if (tiles.length >= 2) {
    const stride = tiles[1].getBoundingClientRect().left - tiles[0].getBoundingClientRect().left;
    if (stride > 0) tileStride.value = stride;
  } else if (tiles.length === 1) {
    const tileWidth = tiles[0].getBoundingClientRect().width;
    if (tileWidth > 0) tileStride.value = tileWidth;
  }
};

let resizeObserver: ResizeObserver | null = null;

onMounted(() => {
  measureDimensions();
  if (typeof ResizeObserver !== 'function' || !carouselRoot.value) return;
  resizeObserver = new ResizeObserver(measureDimensions);
  resizeObserver.observe(carouselRoot.value);
});

onUnmounted(() => {
  resizeObserver?.disconnect();
  resizeObserver = null;
});

const splideOptions = computed(() => ({
  autoWidth: true,
  arrows: false,
  pagination: false,
  gap: '0.75rem',
  drag: 'free' as const,
  padding: {
    left: '1rem',
    right: '1rem',
  },
}));

const isActive = (ot: OrderType): boolean => currentOrderType.value?.id === ot.id;

const selectOrderType = async (ot: OrderType): Promise<void> => {
  switching.value = true;
  try {
    await navigateToOrderTypeHome(ot.id);
  } catch (error) {
    console.error('Failed to switch order type:', error);
  } finally {
    switching.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: "wc-mobile-ot-switcher",
    ref_key: "carouselRoot",
    ref: carouselRoot,
    class: "wc-mobile-ot-switcher"
  }, [
    (!isDragEnabled.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(visibleOrderTypes), (ot) => {
            return (_openBlock(), _createElementBlock("button", {
              key: ot.id,
              type: "button",
              class: _normalizeClass(["wc-mobile-ot-switcher__tile", { active: isActive(ot) }]),
              "aria-current": isActive(ot) ? 'true' : undefined,
              disabled: switching.value,
              onClick: ($event: any) => (selectOrderType(ot))
            }, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(WCImage, {
                  imageSrc: `${cdn.value}/api/img/${ot.image}`,
                  imageAlt: ot.name
                }, null, 8, ["imageSrc", "imageAlt"])
              ]),
              _cache[0] || (_cache[0] = _createTextVNode()),
              _createElementVNode("span", _hoisted_4, _toDisplayString(ot.name), 1)
            ], 10, _hoisted_2))
          }), 128))
        ]))
      : (_openBlock(), _createBlock(WCCarousel, {
          key: 1,
          isSlider: true
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Splide), {
              options: splideOptions.value,
              role: "list"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(visibleOrderTypes), (ot) => {
                  return (_openBlock(), _createBlock(_unref(SplideSlide), {
                    key: ot.id,
                    role: "listitem"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("button", {
                        type: "button",
                        class: _normalizeClass(["wc-mobile-ot-switcher__tile", { active: isActive(ot) }]),
                        "aria-current": isActive(ot) ? 'true' : undefined,
                        disabled: switching.value,
                        onClick: ($event: any) => (selectOrderType(ot))
                      }, [
                        _createElementVNode("div", _hoisted_6, [
                          _createVNode(WCImage, {
                            imageSrc: `${cdn.value}/api/img/${ot.image}`,
                            imageAlt: ot.name
                          }, null, 8, ["imageSrc", "imageAlt"])
                        ]),
                        _cache[1] || (_cache[1] = _createTextVNode()),
                        _createElementVNode("span", _hoisted_7, _toDisplayString(ot.name), 1)
                      ], 10, _hoisted_5)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }, 8, ["options"])
          ]),
          _: 1
        }))
  ], 512))
}
}

})